import { Box, Tab, TabList, TabPanel, TabPanels, TabsContext } from "monday-ui-react-core";
import { useCallback, useState } from "react";

import { DocumentationPanel } from "@/components/DocumentationPanel";
import { ExamplesPanel } from "@/components/ExamplesPanel";
import { RunPanel } from "@/components/RunPanel";
import type { Command } from "@/services/runcli";

import { AppTabContent } from "./AppTabContent";

export function AppTabs() {
  const [activeTabId, setActiveTabId] = useState(0);
  const [editableCommand, setEditableCommand] = useState("");

  const onCopy = useCallback((command: Command) => {
    setActiveTabId(0);
    setEditableCommand(command.text);
  }, []);

  const onTabClick = useCallback((tabId: number) => {
    setActiveTabId(tabId);
  }, []);

  return (
    <Box marginTop={Box.marginTops.SMALL}>
      <TabsContext activeTabId={activeTabId}>
        <TabList tabType="compact">
          <Tab onClick={onTabClick}>Run</Tab>
          <Tab onClick={onTabClick}>Examples</Tab>
          <Tab onClick={onTabClick}>Documentation</Tab>
          {/*
          <Tab onClick={onTabClick}>Get ACLI</Tab>
          */}
        </TabList>
        <TabPanels>
          <TabPanel>
            <AppTabContent>
              <RunPanel editableCommand={editableCommand} />
            </AppTabContent>
          </TabPanel>
          <TabPanel>
            <AppTabContent>
              <ExamplesPanel onCopy={onCopy} />
            </AppTabContent>
          </TabPanel>
          <TabPanel>
            <AppTabContent>
              <DocumentationPanel />
            </AppTabContent>
          </TabPanel>
          {/*
          <TabPanel>
            <AppTabContent>
              <AcliSetupPanel />
            </AppTabContent>
          </TabPanel>
          */}
        </TabPanels>
      </TabsContext>
    </Box>
  );
}
